<template>
  <v-sheet height="100%" color="transparent">
    <div v-if="!loading">
      <div class="img-cover relative">
        <img
          loading="lazy"
          :src="
            files +
            (w <= 600 && item.img_cover_mobile
              ? item.img_cover_mobile
              : item.img_cover_desktop) +
            `?resize=1&w=${w}`
          "
          :alt="item.title"
          v-if="item.title"
          class="primary lighten-2"
        />

        <div class="caption">
          <div>
            <div
              class="caption-title text-uppercase white--text font-weight-black text-center"
              v-if="item.title"
            >
              {{ item.title }}
            </div>

            <div
              class="caption-category white--text font-weight-regular text-center mt-2"
              v-if="item.subtitle"
            >
              {{ item.subtitle }}
            </div>
          </div>
        </div>
      </div>

      <v-container>
        <div
          class="white--text font-weight-regular text-center mt-8 text"
          v-if="item.text"
          v-html="item.text"
        ></div>

        <div class="videos my-12" v-if="item.videos">
          <div class="white--text mb-8 text-center caption-title">
            {{ item.videos.length > 1 ? "Vídeos" : "Vídeo" }}
          </div>

          <div
            class="video mt-6"
            v-for="(video, i) in item.videos"
            :key="i"
            v-html="video"
          ></div>
        </div>

        <div class="images my-12" v-if="item.img.list.length">
          <LightGallery
            :images="item.img.list"
            :index="index"
            :disable-scroll="true"
            @close="index = null"
          />

          <div class="white--text mb-8 text-center caption-title">
            {{ item.img.list.length > 1 ? "Fotos" : "Foto" }}
          </div>

          <v-row>
            <v-col
              cols="12"
              md="6"
              lg="4"
              v-for="(image, i) in item.img.list"
              :key="i"
              @click="index = i"
            >
              <img :src="image" :alt="item.title" class="image" />
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div>
    <v-sheet
      v-else
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </v-sheet>
</template>

<script>
import { getYoutubeCode, getVimeoCode } from "../../utils";
import { LightGallery } from "vue-light-gallery";

export default {
  data: () => ({
    loading: true,
    index: null,
    item: {},
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    w() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 600;
        case "sm":
          return 960;
        case "md":
          return 1264;
        case "lg":
          return 1440;
        default:
          return 1920;
      }
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest("portfolio")
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          if (this.item.videos)
            this.item.videos = this.item.videos.map((video) => {
              if (getYoutubeCode(video))
                return `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${getYoutubeCode(
                  video
                )}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
              else if (getVimeoCode(video))
                return `<iframe width="100%" height="100%" src="https://player.vimeo.com/video/${getVimeoCode(
                  video
                )}?h=a98004a6f7&color=ffffff&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;

              return null;
            });

          if (this.item.img.list.length)
            this.item.img.list = this.item.img.list.map((image) => {
              return this.files + image;
            });
          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    LightGallery,
  },
};
</script>

<style scoped>
.img-cover img {
  display: block;
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  width: 100%;
}

@media screen and (min-width: 600.001px) {
  .img-cover img {
    height: 40vh;
    min-height: 500px;
  }
}

@media screen and (max-width: 600px) {
  .img-cover img {
    aspect-ratio: 1 / 1;
  }
}

.caption {
  align-items: center;
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.caption-title {
  font-size: 37px;
  line-height: 44px;
  letter-spacing: 0.25rem;
}

.text {
  font-size: 16px;
  line-height: 24px;
}

.caption-category {
  font-size: 21px;
}

.videos .video {
  aspect-ratio: 16 / 9;
}

.images .image {
  aspect-ratio: 16 / 9;
  cursor: pointer;
  display: block;
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  width: 100%;
}

@media screen and (max-width: 600px) {
  .caption-title {
    font-size: 22px;
    line-height: 26px;
  }

  .caption-category {
    font-size: 18px;
  }
}
</style>
